jQuery(document).ready(function ($) {
  // Gutenberg Details Block Expand/Collapse
  if ($('.wp-block-details').length) {
    $('.wp-block-details').each(function () {
      const $details = $(this);
      const $summary = $details.find('summary');
      const $content = $summary.next();

      if (!$content.length) return;

      // Hide content initially if not open
      if (!$details.attr('open')) {
        $content.hide();
      }

      $summary.on('click', function (e) {
        e.preventDefault();

        if ($details.attr('open')) {
          // Close animation
          $content.slideUp(300, function () {
            $details.removeAttr('open');
          });
        } else {
          // Open animation
          $details.attr('open', '');
          $content.slideDown(300);
        }
      });
    });
  }

  // FAQs
  if ($('.faq-toggle').length) {
    $('.faq-toggle').on('click', function () {
      const $button = $(this);
      const expanded = $button.attr('aria-expanded') === 'true';
      const $icon = $button.find('i');
      const contentId = $button.attr('aria-controls');
      const $content = $('#' + contentId);

      // Toggle state
      $button.attr('aria-expanded', !expanded);
      $content.prop('hidden', expanded);

      // Swap icon classes
      if (expanded) {
        $icon.removeClass('fa-minus').addClass('fa-plus');
      } else {
        $icon.removeClass('fa-plus').addClass('fa-minus');
      }
    });
  }
});
